export default __webpack_public_path__ + "static/media/comm 6.9aaf03d2.png";